"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function GoogleWorkspaceCloud(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 48 48",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#E9ECEF",
    d: "M36.691 30.609c3.354-.336 5.484-4.477 5.06-8.066-.631-5.307-6.077-5.231-7.21-5.301-.085 0-.124-.108-.072-.178.378-.5.645-1.103.82-1.706.49-1.617.268-3.38-.533-4.85-2.794-5.124-8.141-2.125-8.141-2.125-4.208-6.55-11.49-4.35-11.49-4.35-8.022 1.866-7.559 10.28-7.48 11.325 0 .058-2.388.089-1.627.693-4.005.558-5.221 2.801-5.807 5.306-.847 3.602.822 8.415 5.68 9.366h5.035l.625-3.348 1.505-3.323 2.605-2.492 4.644-2.34 5.457-.551 4.794 1.87 3.426 2.91 2.299 4.256.397 2.91",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87949F",
    d: "M47.937 21.868c-.693-5.43-6.172-6.456-8.12-6.652.298-.44.544-.963.738-1.562.582-1.782.35-3.773-.64-5.455-2.912-4.982-8.185-3.105-9.498-2.538-4.924-6.797-13.263-4.542-13.354-4.517-9.503 2.86-9.555 12.038-9.458 13.927-4.011.586-6.463 2.533-7.298 5.808-.628 2.47-.285 4.957.951 6.834 1.126 1.714 2.95 2.848 5.28 3.276h3.933c.058 0 .11-.013.155-.038-.006.605.039 1.21.123 1.814.938 6.595 6.54 11.326 13.211 11.326.142 0 .291 0 .433-.007l-2.91 2.312a.462.462 0 00-.072.662c.097.12.233.176.375.176.11 0 .214-.038.304-.107l4.322-3.427-4.102-4.17a.492.492 0 00-.685-.012.461.461 0 00-.013.667l2.905 2.948c-6.425.271-11.905-4.195-12.81-10.494-.686-4.825 1.779-9.656 6.133-12.03 3.312-1.802 7.207-2.08 10.675-.757 3.467 1.323 6.114 4.063 7.265 7.502 1.042 3.118.75 6.438-.822 9.342a.457.457 0 00.201.636c.24.126.53.038.654-.195a12.52 12.52 0 001.546-6.167c.103-.006.24-.006.46-.006 1.358-.013 3.214-.02 4.004-.095 1.61-.15 3.066-.97 4.212-2.368 1.468-1.79 2.193-4.334 1.902-6.633zm-2.491 6.192c-.705.863-1.928 1.934-3.707 2.098-.764.069-2.672.081-3.94.088h-.466a12.494 12.494 0 00-.634-3.188c-1.236-3.716-4.089-6.664-7.828-8.087-3.74-1.43-7.939-1.134-11.51.812-3.96 2.154-6.463 6.192-6.709 10.52a.354.354 0 00-.181-.051H6.64c-2.135-.397-3.74-1.38-4.755-2.935-1.126-1.707-1.437-3.988-.86-6.262.763-3.01 3.085-4.793 6.909-5.29a.476.476 0 00.42-.505c-.084-1.077-.543-10.57 8.915-13.41.324-.095 8.12-2.18 12.7 4.485l.188.27.291-.15c.233-.127 5.83-2.974 8.805 2.116.887 1.512 1.1 3.288.583 4.875-.227.687-.518 1.26-.874 1.695a.479.479 0 00-.071.497c.071.164.233.271.414.284 1.197.07 7.194.674 7.88 6.047.272 2.11-.395 4.44-1.74 6.085v.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H12V12H0z",
    transform: "translate(17.925 24)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#prefix__google-workspace-cloud__clip0_23001_7360)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M29.682 30.136a6.9 6.9 0 00-.108-1.227h-5.65v2.321h3.227a2.759 2.759 0 01-1.2 1.8v1.499h1.938c1.133-1.044 1.799-2.582 1.799-4.408l-.006.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M23.925 35.998c1.46.04 2.88-.48 3.97-1.454l-1.937-1.5a3.62 3.62 0 01-5.398-1.9h-2.003v1.552a5.997 5.997 0 005.359 3.299l.009.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M20.57 31.14a3.544 3.544 0 010-2.279v-1.556h-2.004a5.997 5.997 0 000 5.397l2.003-1.553v-.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M23.925 26.387a3.239 3.239 0 012.294.9l1.706-1.724A5.763 5.763 0 0023.913 24a5.997 5.997 0 00-5.359 3.299l2.003 1.553a3.574 3.574 0 013.356-2.474l.012.01z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__google-workspace-cloud__clip0_23001_7360"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H12V12H0z",
    transform: "translate(17.925 24)"
  }))));
}

GoogleWorkspaceCloud.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
GoogleWorkspaceCloud.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = GoogleWorkspaceCloud;
exports["default"] = _default;